import { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Trans } from '@lingui/react/macro'

import { useGetCustomer } from '@jotta/grpc-connect-client/customer'
import type { Customer } from '@jotta/grpc-connect-openapi/customer'
import { showIntercom } from '@jotta/intercom'
import { CookieConsentContext } from '@jotta/ui/CookieConsentModal'
import { Headline1 } from '@jotta/ui/Headline'
import { useBrandCode } from '@jotta/ui/useBrandTheme'

import { PublicLayout } from '../components/Layout/PublicLayout'

import UpgradePng from './upgrade.png'

export function ConvertedToJottacloud({ customer }: { customer: Customer }) {
  const customer_email = customer.email
  return (
    <>
      <header className="title-md text-center">
        <Trans>Welcome to Jottacloud!</Trans>
      </header>

      <img src={UpgradePng} className="h-64 px-16" />

      <p>
        <Trans>
          You are now a Jottacloud customer!{' '}
          <strong>All your data is safely stored in Jottacloud</strong>, but you
          will need to download the Jottacloud apps in order to continue backing
          up all your data.
        </Trans>
      </p>

      <p>
        <Trans>
          Please check your email ({customer_email}) for instructions on how to
          get started with the{' '}
          <a href="https://www.jottacloud.com/apps" className="link">
            Jottacloud service
          </a>
          .
        </Trans>
      </p>

      <p>
        <Trans>
          If you have any questions, please{' '}
          <a
            className="link"
            href="mailto:support@jottacloud.com"
            onClick={showIntercom}
            target="_blank"
            rel="noreferrer"
          >
            contact support
          </a>
          .
        </Trans>
      </p>
    </>
  )
}

function Upgraded() {
  return (
    <>
      <Headline1>
        <Trans>Your account has been upgraded!</Trans>
      </Headline1>
      <img src={UpgradePng} className="h-80" />
      <p>
        <Trans>
          Congratulations on your new subscription! You will shortly receive a
          payment receipt by email.
        </Trans>
      </p>
      <Link to="/web/billing" className="link">
        <Trans>Continue</Trans>
      </Link>
    </>
  )
}

export function UpgradeAccepted() {
  const { data: customer } = useGetCustomer()
  const siteBrandCode = useBrandCode()
  const customerBrandCode = customer
    ? customer.brandingInfo?.brandCode
    : undefined

  const { requestCookieConsent } = useContext(CookieConsentContext)
  useEffect(requestCookieConsent, [requestCookieConsent])

  return (
    <PublicLayout
      section="upgradeaccepted"
      className="mx-auto flex max-w-xl flex-col items-center gap-4 py-8 text-center"
    >
      {customer &&
      customerBrandCode !== siteBrandCode &&
      customerBrandCode === 'JOTTACLOUD' ? (
        <ConvertedToJottacloud customer={customer} />
      ) : (
        <Upgraded />
      )}
    </PublicLayout>
  )
}
